var InitDropzone = function () {
    
    var inner = {
        selector:      '#js-dropzone-upload',
        filesSelector: '#js-prilohy-upload',
        serverSideUrl: $("#js-dropzone-upload").data("href"),
        fileNames:     [],
        
        defaultMessage:     $("#js-dropzone-label").html(),
        invalidFileType:    $("#js-invalidFileType").val(),
        
        init: function () {
            
            if(!$(inner.selector).length) {
                return false;
            }
            
            var submitBtn = $(inner.selector).closest("form").find("input[type=submit]");
            
            $(inner.selector).dropzone({
                dictDefaultMessage: inner.defaultMessage,
                dictInvalidFileType: inner.invalidFileType,
                url:           inner.serverSideUrl,
                maxFilesize:   20,
                acceptedFiles: 'image/*, .pdf, .txt, .zip, .rar, .doc, .docx, .xls, .xlsx, .csv',
                
                processing: function(file) {
                    
                    submitBtn.hide();
                },
                
                success:       function (file, xhr) {
                    
                    var snippets = xhr.snippets;
                    if (snippets) {
                        $.nette.ext('snippets').updateSnippets(snippets);
                    }
                    
                    inner.fileNames.push(file.name);

                    $(inner.filesSelector).val(JSON.stringify(inner.fileNames));

                    submitBtn.show();

                    if (file.previewElement) {
                        return file.previewElement.classList.add("dz-success");
                    }
                }
            });
            
            return true;
        }
    };

    return inner;
};

$(function () {
    
    var dropzone = InitDropzone();
    dropzone.init();
    
});